import * as React from 'react';

import { cn } from './lib/utils';

type InputProps = React.ComponentProps<'input'> & {
  error?: string;
};

function Input({ className, type, error, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input h-10 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 md:text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50  placeholder:text-xs md:placeholder:text-sm text-sm',
        'focus-visible:border-ring',
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
        className,
        error && 'border-destructive',
      )}
      {...props}
    />
  );
}

export { Input };
